import React from "react";
import '../assets/styles/Footer.scss'

function Footer() {
  return (
    <footer>
      <p>{new Date().getFullYear()} Bikmin Software Solutions</p>
    </footer>
  );
}

export default Footer;